import React, { Component } from "react";
import "./UpImage.css";
// import S3 from "react-aws-s3"; // ❌ eliminado
import { Icon, notification, Modal } from "antd";
import { API_URL } from "../../_config";
import CarFileList from "./CarFileList";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { DndProvider } from "react-dnd";
// import update from "immutability-helper"; // ❌ ya no usamos
import { store } from "../../_helpers";
import axios from "axios";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import { Row, Col, Button } from "shards-react";

const cookies = new Cookies();

const openNotificationWithIcon = (type, til, msg) => {
  notification[type]({
    message: til,
    description: msg,
    top: 70,
  });
};

/** Construye headers EXACTOS según X-Amz-SignedHeaders de la URL presignada */
function buildS3Headers(presign, file) {
  const signed = (presign.signed_headers || "")
    .toLowerCase()
    .split(";")
    .filter(Boolean);

  const h = new Headers();
  if (signed.includes("x-amz-server-side-encryption")) {
    h.set("x-amz-server-side-encryption", "AES256");
  }
  if (signed.includes("content-disposition")) {
    h.set("Content-Disposition", "inline");
  }
  if (signed.includes("content-type")) {
    h.set("Content-Type", file.type);
  }
  if (signed.includes("x-amz-acl")) {
    const m = presign.url && presign.url.match(/[?&]x-amz-acl=([^&]+)/i);
    if (m) h.set("x-amz-acl", decodeURIComponent(m[1]));
  }
  return h;
}

/** util para reordenar sin mutar */
function reorder(list, from, to) {
  const arr = Array.isArray(list) ? [...list] : [];
  if (
    from === to ||
    from < 0 ||
    to < 0 ||
    from >= arr.length ||
    to >= arr.length
  ) {
    return arr;
  }
  const [drag] = arr.splice(from, 1);
  arr.splice(to, 0, drag);
  return arr;
}

class UpImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hightlight: false,
      updated: false,
      reflejar: false,
      listFiles: [],
      previewImage: "",
      previewVisible: false,
    };
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      listFiles: Array.isArray(this.props.filelist) ? this.props.filelist : [],
    });
  }

  // UI: abrir selector, DnD y preview
  openFileDialog = () => {
    if (this.props.disabled) return;
    if (this.fileInputRef.current) this.fileInputRef.current.click();
  };

  handlePreview = (index) => {
    const Img = (this.state.listFiles || []).find((_, i) => i === index);
    if (!Img) return;
    this.setState({ previewImage: Img.url, previewVisible: true });
  };

  handleCancel = () => this.setState({ previewVisible: false });

  onFilesAdded = (evt) => {
    if (this.props.disabled) return;
    const files = evt.target.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      this.props.onFilesAdded(array);
    }
    // permitir volver a seleccionar el mismo archivo
    if (this.fileInputRef.current) this.fileInputRef.current.value = "";
  };

  onDragOver = (evt) => {
    evt.preventDefault();
    if (this.props.disabled) return;
    this.setState({ hightlight: true });
  };

  onDragLeave = () => this.setState({ hightlight: false });

  onDrop = (event) => {
    event.preventDefault();
    if (this.props.disabled) return;
    const files = event.dataTransfer.files;
    if (this.props.onFilesAdded) {
      const array = this.fileListToArray(files);
      this.props.onFilesAdded(array);
    }
    this.setState({ hightlight: false });
  };

  fileListToArray(list) {
    const array = [];
    for (let i = 0; i < list.length; i++) {
      const file = list.item(i);
      if (!file) continue;

      const hash = this.stringToHash(file.name);

      // mostrar item "load"
      const cnt = { hash, id: hash, image_order: 1, url: file, state: "load" };
      this.setState((state) => ({ listFiles: [...state.listFiles, cnt] }));

      // subir en background
      this.subir(file, hash);
      array.push(file);
    }
    return array;
  }

  stringToHash($string) {
    const string = $string + Date.now();
    let hash = 0;
    if (string.length === 0) return hash;
    for (let i = 0; i < string.length; i++) {
      let char = string.charCodeAt(i);
      hash = (hash << 15) - hash + char;
      hash = hash & hash;
    }
    return hash;
  }

  /**
   * NUEVO flujo: presign (backend) → PUT (S3 con fetch) → (opcional) fix-metadata → registrar URL en API
   */
  subir = async (file, hash) => {
    try {
      const isImage = /image\/(jpeg|jpg|png|webp)/i.test(file.type);
      if (!isImage) {
        openNotificationWithIcon("error", "Formato inválido", "Solo .JPG, .PNG o .WEBP");
        return;
      }

      notification.open({
        message: "Subiendo imagen",
        description: "Este proceso puede demorar unos minutos",
        icon: <Icon type="loading" style={{ color: "#4caf50" }} />,
        top: 70,
      });

      const dealerId = cookies.get("dealer").id;
      const token = store.getState().authentication.user.token;

      // 1) presign
      const presResp = await axios.get(`${API_URL}api/s3/presign`, {
        params: {
          dealer_id: dealerId,
          vehicle_id: this.props.id_vehicle,
          filename: file.name,
          contentType: file.type,
          token,
        },
      });
      const presign = presResp.data;

      // 2) headers EXACTOS
      const headers = buildS3Headers(presign, file);

      // 3) PUT con fetch (no axios, para que no inyecte Content-Type)
      const putRes = await fetch(presign.url, { method: "PUT", headers, body: file });
      if (!putRes.ok) {
        const txt = await putRes.text();
        throw new Error(`S3 PUT ${putRes.status}: ${txt}`);
      }

      // 4) si no firmamos Content-Type, corregir metadata (no bloquea si falla)
      if (!String(presign.signed_headers || "").toLowerCase().includes("content-type")) {
        try {
          await axios.post(
            `${API_URL}api/s3/fix-metadata`,
            { key: presign.key, contentType: file.type },
            { params: { token } }
          );
        } catch (_) {
          // no bloquear UX
        }
      }

      // 5) registrar URL final en tu API
      await this.onUpdateItem(presign.public_url, hash);

      notification.destroy();
      notification.open({
        message: "Imagen subida exitosamente",
        description: "La imagen se cargó correctamente",
        icon: <Icon type="check-circle" style={{ color: "#4caf50" }} />,
        top: 70,
      });
    } catch (err) {
      notification.destroy();
      notification.open({
        message: "No se pudo subir la imagen",
        description: "Ocurrió un error durante la subida. Intente nuevamente.",
        icon: <Icon type="stop" style={{ color: "#d32f2f" }} />,
        top: 70,
      });

      // marcar el item con error en la UI
      this.setState(({ listFiles }) => ({
        listFiles: (listFiles || []).map((it) =>
          it.hash === hash ? { ...it, state: "error" } : it
        ),
      }));
    }
  };

  onUpdateItem = async (i, hash) => {
    try {
      const token = store.getState().authentication.user.token;
      const dealerId = cookies.get("dealer").id;

      const response = await axios.post(
        `${API_URL}api/dealer/${dealerId}/vehicle/${this.props.id_vehicle}/image/link`,
        { url: i, id: true },
        { params: { token } }
      );

      // Si está publicado en portales, activamos CTA de reflejar
      if (
        this.props.prop &&
        this.props.prop.initialValues &&
        this.props.prop.initialValues.publish &&
        (this.props.prop.initialValues.publish.olx === true ||
          this.props.prop.initialValues.publish.deMotores === true ||
          this.props.prop.initialValues.publish.autoCosmos === true ||
          this.props.prop.initialValues.publish.mercadolibre === true)
      ) {
        this.setState({ reflejar: true });
      }

      // Actualizar lista
      this.setState(({ listFiles }) => ({
        listFiles: (listFiles || []).map((item) =>
          item.hash === hash
            ? {
              hash,
              id: response.data.id,
              url: i,
              state: "done",
            }
            : item
        ),
      }));
    } catch (_) {
      notification.destroy();
      notification.open({
        message: "No se pudo subir la imagen",
        description:
          "Ha ocurrido un error en el proceso, por favor, intente más tarde",
        icon: <Icon type="stop" style={{ color: "#d32f2f" }} />,
        top: 70,
      });
    }
  };

  removeItem = (index, hash) => {
    axios
      .delete(
        `${API_URL}api/dealer/${cookies.get("dealer").id}/vehicles/image/${hash}`,
        { params: { token: store.getState().authentication.user.token } }
      )
      .then(() => {
        this.props.enviarData();
        this.setState({ listFiles: (this.state.listFiles || []).filter((i) => i.id !== hash) });
      })
      .catch(() => {
        notification.destroy();
        notification.open({
          message: "No se pudo eliminar la imagen",
          description:
            "Ha ocurrido un error en el proceso, por favor, intente más tarde",
          icon: <Icon type="stop" style={{ color: "#d32f2f" }} />,
          top: 70,
        });
      });
  };

  reflejar = () => {
    this.props.enviarData();
    this.setState({ reflejar: false });
  };

  confirm_order = () => {
    const newItem = (this.state.listFiles || []).map((j) => j.id);
    axios
      .post(
        `${API_URL}api/dealer/${cookies.get("dealer").id}/vehicle/${this.props.id_vehicle}/order-images`,
        { newItem },
        { params: { token: store.getState().authentication.user.token } }
      )
      .then(() => {
        this.props.enviarData();
        this.setState({ updated: false });
      })
      .catch(() => {
        alert("Ocurrió un error al intentar guardar");
      });
  };

  saveOrder = () => {
    this.setState({ updated: true });
  };

  // ✅ arrow function (no se pierde `this`) + defensas
  moveImage = (dragIndex, hoverIndex) => {
    this.setState((prev) => ({
      listFiles: reorder(prev.listFiles, dragIndex, hoverIndex),
      updated: true,
    }));
  };

  render() {
    const isTouchDevice = () => "ontouchstart" in window;
    const backendForDND = isTouchDevice() ? TouchBackend : HTML5Backend;

    return (
      <div className="clearfix content-inputCustomFile container-fluid">
        <div className="row">
          <div
            className={`inputCustomFile ${this.state.hightlight ? "Highlight" : ""}`}
            onDragOver={this.onDragOver}
            onDragLeave={this.onDragLeave}
            onDrop={this.onDrop}
            onClick={this.openFileDialog}
            style={{ cursor: this.props.disabled ? "default" : "pointer" }}
          >
            <input
              ref={this.fileInputRef}
              className="FileInput"
              type="file"
              multiple
              onChange={this.onFilesAdded}
            />
            <span>Subir imagenes Haga clic o arrastre sus imagenes a esta área</span>
          </div>

          <div className="left ant-upload-list ant-upload-list-picture-card">
            <DndProvider backend={backendForDND}>
              {this.state.listFiles ? (
                <CarFileList
                  images={this.state.listFiles}
                  remove={this.removeItem}
                  moveImage={this.moveImage}
                  preview={this.handlePreview}
                />
              ) : (
                ""
              )}
            </DndProvider>
          </div>
        </div>

        {this.state.updated === true && (
          <Row>
            <Col sm={3}>
              <Button onClick={this.confirm_order} className="w-100">
                Confirmar orden
              </Button>
            </Col>
            <Col sm={9}>
              <p>
                Nota: Debe confirmar el orden para que este se vea reflejado y sea
                guardado, de lo contrario, los cambios en el orden no serán guardados.
              </p>
            </Col>
          </Row>
        )}

        {this.state.reflejar === true && (
          <Row>
            <Col sm={3}>
              <Button onClick={this.reflejar} className="w-100">
                Reflejar cambios
              </Button>
            </Col>
            <Col sm={9}>
              <p>
                Nota: Los cambios han sido guardados exitosamente en nuestra base de
                datos, pero es necesario que usted presione el botón reflejar, para que
                estos cambios aparezcan en los portales publicados.
              </p>
            </Col>
          </Row>
        )}

        <Modal
          visible={this.state.previewVisible}
          title={null}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="preview" style={{ width: "100%" }} src={this.state.previewImage} />
        </Modal>
      </div>
    );
  }
}

export default connect()(UpImage);
